import * as zod from 'zod';

import {
  ExternalControlControlledBy,
  ExternalControlServoConfig,
  ExternalControlStreamType,
} from './Arguments';

/**
 * Published into the routine-runner state so any client can read the live
 * session straight from the runner (the single shared source of truth)
 * instead of re-deriving it from the robot's `latestRoutineID` + a
 * routine-row lookup, which races against ephemeral-routine reaping.
 *
 * `servoConfig` is the *effective* tuning — every scalar field the request
 * omitted resolved to its default — so a client that did not start the session
 * (it came from the REST API, the SDK, or another browser) sees the settings
 * the session started with rather than its own local draft. One bag serves both
 * primitives, so some fields are inert for one: `positionSmoothingTimeConstantMs`
 * is ServoJ-only, while `referenceFrame` and `motionScalingLimits` are ServoL-only.
 * `motionScalingLimits` stays optional: absent is its resolved "no limit" state.
 */
export default zod.object({
  controlledBy: ExternalControlControlledBy,
  streamType: ExternalControlStreamType,
  servoConfig: ExternalControlServoConfig.required().partial({
    motionScalingLimits: true,
  }),
});
